import { FC } from 'react'
import { MenuFamily } from '../app/types/catalog-types'
import { urls } from '../navigation'
import { useURLLang } from '../app/main-slice'
import styles from './choose-sub-family.module.css'
import { Link } from 'react-router-dom'
import ChooseHeader from '../controls/chooseHeader/choose-header'

export type ChooseFamilyProps = {
    categoryId: string
    subFamilies: MenuFamily[]
    familyName: string
}

export const ChooseSubFamily: FC<ChooseFamilyProps> = ({ categoryId, subFamilies, familyName }) => {

    const lang = useURLLang();

    const urlLink = (subfamily: MenuFamily) => {
        return urls.familyCfg(lang, categoryId, subfamily.id)
    }

    return <>
        <ChooseHeader title={familyName || ""} urlBack={urls.category(lang, categoryId)}/>

        <ul className={styles.subFamilyContainer}>
            {
                subFamilies.map((subFamily) => 
                    <li className={`${styles.subFamilyCard}`} key={subFamily.id}>
                       {subFamily?.image && <Link to={ urlLink(subFamily) }>
                            <div className={styles.subFamilyImageCard} dangerouslySetInnerHTML={{ __html: subFamily?.image || "" }}/>
                            <h3 className={styles.subFamilyName}>{ subFamily.name }</h3>
                        </Link>}
                    </li>)
            }
        </ul>

    </>

}